import { storyblokEditable } from "gatsby-source-storyblok"

import ArticleVideo from "@components/elements/V2/ArticleVideo"
import { getUrlFromStoryblokLink, linkIsNotNull } from "@utils/storyblok"
import React from "react"

const StoryblokVideo = ({
  blok,
  mobileGridOrder,
}: Storyblok.BlokProps<Storyblok.ArticleVideo>) => {
  const videoUrl =
    blok.videoUrl && linkIsNotNull(blok.videoUrl)
      ? getUrlFromStoryblokLink(blok.videoUrl)
      : blok.video?.filename || ""

  return (
    <ArticleVideo
      videoUrl={videoUrl}
      coverImageUrl={blok.videoCoverImage?.filename || ""}
      coverImageAlt={blok.videoCoverImage?.alt}
      videoAlt={blok.videoAlt}
      mobileGridOrder={mobileGridOrder}
      // @ts-ignore to have more strict typing compared to Storybloks generic object typing
      {...storyblokEditable(blok)}
    />
  )
}

export default StoryblokVideo
